<template>
  <div>
    <vs-popup :title="$t('CreateSerial')" :active.sync="showModal">
      <div class="vx-row w-full mb-2 pr-4">
        <vs-input
          class="inputx w-1/3"
          v-model="firstSerial"
          label="اولین شماره سریال"
          @keyup.enter="tabToNextInput()"
        />
        <vs-input
          class="inputx w-1/3 mx-4"
          v-model="lastSerial"
          ref="lastSerial"
          label="اخرین شماره سریال"
          :disabled="!beFirstSerial"
          @keyup.enter="addSerialAccumulative()"
        />
        <vs-button
          size="small"
          radius
          color="success"
          type="gradient"
          icon-pack="feather"
          icon="icon-plus"
          @click.prevent="addSerialAccumulative()"
          class="mt-8 mx-8"
          :disabled="!beFirstAndLastSerial"
        ></vs-button>
      </div>
      <vs-table :data="modelForShowInPage" class="custom-tbl">
        <template slot="thead">
          <th>#</th>
          <th>{{ $t("SerialNumber") }}</th>
          <th>{{ $t("CountOfOperatorRequested") }}</th>
          <th>{{ $t("CountOfRegistered") }}</th>
          <th>{{ $t("RemainingCountForCheckout") }}</th>
          <th>{{ $t("Action") }}</th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr
            :key="i"
            v-for="(tr, i) in data"
            :class="
              tr.remainingCountForCheckout == tr.serialsInfo.length ||
              tr.remainingCountForCheckout == 0
                ? 'bg-success'
                : ''
            "
          >
            <vs-td style="width: 5%">
              {{ i + 1 }}
            </vs-td>
            <vs-td style="width: 20%">
              {{ tr.itemCode }}
            </vs-td>
            <vs-td style="width: 20%">
              {{ tr.remainingCountForCheckout }}
            </vs-td>
            <vs-td style="width: 20%">
              {{ tr.serialsInfo.length }}
            </vs-td>
            <vs-td style="width: 20%">
              {{
                tr.serialsInfo.length
                  ? tr.remainingCountForCheckout - tr.serialsInfo.length
                  : tr.remainingCountForCheckout
              }}
            </vs-td>
            <vs-td style="width: 15%">
              <!-- <vs-button
                radius
                color="danger"
                size="small"
                type="gradient"
                icon-pack="feather"
                icon="icon-x"
                @click.prevent="deleteAllSerialForRow(i)"
                class="d-inline"
              ></vs-button> -->
            </vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td style="width: 5%">
              {{ modelForShowInPage.length + 1 }}
            </vs-td>
            <vs-td style="width: 20%">
              {{ $t("WrongBarcode") }}
            </vs-td>
            <vs-td style="width: 20%">
              ---
            </vs-td>
            <vs-td style="width: 20%">
              {{ countWrongBarcode }}
            </vs-td>
            <vs-td style="width: 20%">
              ---
            </vs-td>
            <vs-td style="width: 15%">
              ----
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-button
        type="filled"
        class="float-right mb-4 mt-4"
        @click.prevent="submitSerialForm"
        >{{ $t("Save") }}</vs-button
      >
    </vs-popup>
  </div>
</template>
<style lang="scss">
.vs-con-input input {
  text-align: right;
}
.custom-tbl td {
  padding: 0.5rem 1rem !important;
}
</style>
<script>
import { mapActions } from "vuex";

export default {
  name: "warehouseManagement_CheckOutTransactions_SerialPopup",
  props: {
    show: { default: false },
    basketId: "",
     storeId: "",
    dischargePermissionId: { default: 0 }
  },
  data() {
    return {
      newListSerialsInfo: [],
      fixedPartSerials: [],
      VariablePartSerials: [],
      lastCharater: 0,
      lastIndexRegistered: 0,
      lastSerial: "",
      firstSerial: "",
      beFirstSerial: false,
      serialsIncluesSpace: false,
      beFirstAndLastSerial: false,
      countWrongBarcode: 0,
      NumberOfZeros: 0,
      zeros: "",
      model: {},
      modelForAddSerial: {},
      listOfSerialsSeparationWithItemCode: [],
      modelForShowInPage: [],
      AbilityAddSerial: true,
      addNewSerial: false,
      serialService: "",
      itemCodeCurrentInApiList: ""
    };
  },

  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish", "", "notNew");
        this.fixedPartSerials = [];
        this.VariablePartSerials = [];
        this.firstSerial = "";
        this.lastSerial = "";
      }
    }
  },
  methods: {
    ...mapActions({
      GetAllSeriesRelatedToCurrentDischrgePermission:
        "draftOrder/GetAllSeriesRelatedToCurrentDischrgePermission"
    }),
    async getAllSerialsAvailable() {
      this.listOfSerialsSeparationWithItemCode = [];
      this.model = {
        storeId: "4",
        shelveId: "1",
        dischargePermissionId: this.dischargePermissionId
      };
      this.GetAllSeriesRelatedToCurrentDischrgePermission(this.model).then(
        r => {
          this.listOfSerialsSeparationWithItemCode = r;
        }
      );
    },
    tabToNextInput() {
      this.beFirstSerial = true;
      this.$refs.lastSerial.$el.querySelector("input").focus();
    },

    checkSerialRepeatability(data, newSerial) {
      for (let index = 0; index < data.serialsInfo.length; index++) {
        if (data.serialsInfo[index].serial == newSerial) {
          this.isSerialRepeatability = true;
          return true;
        }
      }
      return false;
    },

    checkSerialAuthorization(newSerial) {
      for (
        let index = 0;
        index < this.listOfSerialsSeparationWithItemCode.length;
        index++
      ) {
        if (
          this.listOfSerialsSeparationWithItemCode[index].serials.includes(
            newSerial
          )
        ) {
          this.itemCodeCurrentInApiList = this.listOfSerialsSeparationWithItemCode[
            index
          ].itemCode;
          return true;
        }
      }
      this.isSerialAuthorization = false;
      return false;
    },
    itemHaveRemaining(data) {
      if (data.remainingCountForCheckout == data.serialsInfo.length) {
        this.isItemHaveRemaining = false;
        return false;
      } else return true;
    },
    findLastIndex() {
      this.lastIndexRegistered = 0;
      for (let index = 0; index < this.modelForShowInPage.length; index++) {
        if (this.modelForShowInPage[index].serialsInfo.length) {
          for (
            let i = 0;
            i < this.modelForShowInPage[index].serialsInfo.length;
            i++
          ) {
            if (
              this.lastIndexRegistered <
              this.modelForShowInPage[index].serialsInfo[i].index
            ) {
              this.lastIndexRegistered = this.modelForShowInPage[
                index
              ].serialsInfo[i].index;
            }
          }
        }
      }
    },
    addSerial(newSerial) {
      if (this.checkSerialAuthorization(newSerial)) {
        for (let index = 0; index < this.modelForShowInPage.length; index++) {
          if (
            this.modelForShowInPage[index].itemCode ==
            this.itemCodeCurrentInApiList
          ) {
            if (
              this.itemHaveRemaining(this.modelForShowInPage[index]) &&
              !this.checkSerialRepeatability(
                this.modelForShowInPage[index],
                newSerial
              )
            ) {
              this.findLastIndex();
              this.lastIndexRegistered += 1;
              var serialNew = {
                serial: newSerial,
                index: this.lastIndexRegistered
              };
              this.modelForShowInPage[index].serialsInfo.push(serialNew);
              this.newListSerialsInfo.push(serialNew);
              serialNew = {};
              this.isAddNewSerial = true;
              break;
            }
          }
        }
        // غیرتکراری ولی غلط
      }

      if (!this.isAddNewSerial) {
        this.countWrongBarcode += 1;
      } else this.isAddNewSerial = false;
    },
    // deleteAllSerialForRow(index) {
    //   this.$swal({
    //     title: "آیا از حذف تمام سریال های این ردیف اطمینان دارید؟",
    //     type: "warning",
    //     showCancelButton: true,
    //     confirmButtonColor: "#3085d6",
    //     cancelButtonColor: "#d33",
    //     confirmButtonText: "بلی",
    //     cancelButtonText: "خیر"
    //   }).then(result => {
    //     if (result.value) {
    //       this.removeAllSerialFromSelectedTransaction(index);
    //       this.modelForShow[index].countOfRegistered = 0;
    //     }
    //   });
    // },
    submitSerialForm() {
      this.$emit("finish", this.modelForShowInPage, "fromBarcodeAcc");
    },
    FindZeroInAtTheBeginningVariablePart(character) {
      if (character == 0) {
        this.NumberOfZeros++;
      } else {
        this.NumberOfZeros = 0;
      }
    },
    SeparationFixedAndVariablePartInSerial(serial) {
      let currentSerial = serial;
      let variablePartLength = 0;
      let serialLength = serial.length;
      for (let index = 0; index < serialLength; index++) {
        this.lastCharater = serial.slice(-1);
        if (Number.isInteger(+this.lastCharater) && this.lastCharater != " ") {
          this.FindZeroInAtTheBeginningVariablePart(this.lastCharater);
          variablePartLength++;
          serial = serial.substring(0, serial.length - 1);
        } else break;
      }
      this.fixedPartSerials.push(serial);
      this.VariablePartSerials.push(
        Number(currentSerial.slice(-variablePartLength))
      );
    },
    addSerialAccumulative() {
      this.SeparationFixedAndVariablePartInSerial(this.firstSerial);
      this.SeparationFixedAndVariablePartInSerial(this.lastSerial);
      if (this.fixedPartSerials[0] == this.fixedPartSerials[1]) {
        var TotalNumberSerials =
          this.VariablePartSerials[1] - this.VariablePartSerials[0] + 1;
        this.$swal({
          title: `آیا از ثبت ${TotalNumberSerials} سریال در بازه ثبت شده ، اطمینان دارید؟`,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "بلی",
          cancelButtonText: "خیر"
        }).then(result => {
          if (result.value) {
            this.zeros = "";
            for (let index = 0; index < this.NumberOfZeros; index++) {
              this.zeros += "0";
            }
            for (let index = 0; index < TotalNumberSerials; index++) {
              if (this.serialsIncluesSpace) {
                this.addSerial(
                  this.fixedPartSerials[0] +
                    " " +
                    (this.VariablePartSerials[0] + index)
                );
              } else {
                this.addSerial(
                  this.fixedPartSerials[0] +
                    this.zeros +
                    (this.VariablePartSerials[0] + index)
                );
              }
            }
            this.fixedPartSerials = [];
            this.VariablePartSerials = [];
            this.firstSerial = "";
            this.lastSerial = "";
          }
        });
      } else {
        this.$swal({
          position: "center-center",
          type: "warning",
          text: "امکان پایش رو سریال وجود ندارد!",
          showConfirmButton: false,
          timer: 2000
        });
      }
    }
  },
  watch: {
    show() {
      if (this.show) {
        this.modelForLocalStorage = localStorage.getItem(
          "basket" + this.basketId + "store" + this.storeId
        );
        this.newSerialsInfo = [];
        this.modelForShowInPage = JSON.parse(this.modelForLocalStorage);
        this.getAllSerialsAvailable();
      }
    },
    firstSerial() {
      if (this.firstSerial) {
        this.beFirstSerial = true;
      } else this.beFirstSerial = false;
    },
    lastSerial() {
      if (this.firstSerial && this.lastSerial) {
        this.beFirstAndLastSerial = true;
      } else this.beFirstAndLastSerial = false;
    }
  }
};
</script>
